import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';

export function MissingField() {
  const { t } = useTranslation();
  return (
    <Typography.Text type="secondary">
      {t('common.errors.noneProvided')}
    </Typography.Text>
  );
}
